import React from 'react'
import SelectieButtonEnumReadonly from './SelectieButtonEnumReadonly'

export default function SelectieButtonEnum({
  type,
  options,
  selected,
  onChange,
}) {
  return SelectieButtonEnumReadonly({
    type: type,
    options: options,
    selected: selected,
    onChange: onChange,
    readonly: false,
  })
}
